import { ApiTags, rootApi } from '../../../../services/rootApi';
import { IRSRequestCreateAndSubmitModel, IServiceReqApprovalModel, IServiceRequest } from '../models';

const TAG = ApiTags.ServiceRequest;

const serviceRequestsApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getServiceRequest: builder.query<IServiceRequest, string>({
      query: (requestId) => `/ServiceRequests/${requestId}`,
      providesTags: (result) => result ? [{ type: TAG, id: result.id }] : [TAG]
    }),

    createServiceRequest: builder.mutation<IServiceRequest, Partial<IServiceRequest>>({
      query: (request) => {
        return {
          url: `/ServiceRequests`,
          method: 'POST',
          body: request
        }
      },

      invalidatesTags: (result, err, args) => {
        if (err) return [];
        return [{ type: TAG, id: args.id }]
      }
    }),

    createAndSubmitServiceRequest: builder.mutation<IRSRequestCreateAndSubmitModel, Partial<IServiceRequest>>({
      query: (request) => {
        return {
          url: `/ServiceRequests/CreateAndSubmit`,
          method: 'POST',
          body: request
        }
      },

      invalidatesTags: (result, err, args) => {
        if (err) return [];
        return [{ type: TAG, id: args.id }]
      }
    }),

    updateServiceRequest: builder.mutation<IServiceRequest, Partial<IServiceRequest>>({
      query: (request) => {
        return {
          url: `/ServiceRequests/${request.id}`,
          method: 'PUT',
          body: request
        }
      },

      invalidatesTags: (result, err, args) => {
        if (err) return [];
        return [{ type: TAG, id: args.id }]
      }
    }),

    updateApprovalStatus: builder.mutation<{ status: string, message: string }, IServiceReqApprovalModel>({
      query: (request) => {
        return {
          url: `/ServiceRequests/UpdateApprovalStatus`,
          method: 'POST',
          body: request
        }
      }
    }),

    resendApprovalRequest: builder.mutation<{ status: string, message: string }, string>({
      query: (requestId) => {
        return {
          url: `/ServiceRequests/ResendApprovalRequest/${requestId}`,
          method: 'POST'
        }
      }
    }),

    resetRequestStatusToDraft: builder.mutation<{ status: string, message: string }, string>({
      query: (requestId) => {
        return {
          url: `/ServiceRequests/ResetRequestStatusToDraft/${requestId}`,
          method: 'POST',
        }
      }
    })
  })
})

export const {
  useGetServiceRequestQuery,
  useLazyGetServiceRequestQuery,
  useCreateServiceRequestMutation,
  useUpdateServiceRequestMutation,  
  useUpdateApprovalStatusMutation,
  useResendApprovalRequestMutation,
  useResetRequestStatusToDraftMutation,
  useCreateAndSubmitServiceRequestMutation
} = serviceRequestsApi;